import React, { FC } from "react";

import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarContainerProps,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";

const DataGridProToolbar: FC<
  React.PropsWithChildren<GridToolbarContainerProps>
> = ({ children, ...props }) => {
  return (
    <GridToolbarContainer {...props}>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport />
      {children}
    </GridToolbarContainer>
  );
};
export default DataGridProToolbar;
